<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refresh"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refresh"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.disciplineCode"
            placeholder="请选择学科"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in disciplineOptions"
              :value="item.disciplineCode"
              :label="item.disciplineName"
              :key="item.disciplineCode"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item prop="grade" class="mb-none">
          <el-select
            size="small"
            value-key="grade"
            v-model="filterForm.grade"
            placeholder="请选择年级"
            clearable
            @change="refresh"
          >
            <el-option
              v-for="item in gradeOptions"
              :value="item.grade"
              :key="item.grade"
              :label="item.gradeName"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索活动名称"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-button size="small" type="primary" @click="onReset">重置</el-button>
        <div class="space"></div>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          >创建活动</el-button
        >
      </div></el-form
    >
    <el-table :data="tableData" style="width: 100%; margin-top: 20px">
      <el-table-column
        prop="schoolYear"
        label="学年"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="schoolTerm"
        label="学期"
        width="100"
        align="center"
        :formatter="termFormatter"
      >
      </el-table-column>

      <el-table-column
        prop="disciplineName"
        label="学科"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="gradeName" label="年级" width="120" align="center">
      </el-table-column>
      <el-table-column
        prop="actTitle"
        label="课外活动名称"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="joinUserNum"
        label="参加人数"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="directorName"
        label="负责人"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="weekActCount"
        label="活动次数（周）"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="actContent" label="活动内容"> </el-table-column>
      <el-table-column prop="actEffect" label="效果"> </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            :disabled="
              userInfo.userId != scope.row.createBy &&
              !userInfo.roleCodes.includes('admin')
            "
            type="text"
            size="small"
            @click="toPathEdit(scope.row)"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              :disabled="
                userInfo.userId != scope.row.createBy &&
                !userInfo.roleCodes.includes('admin')
              "
              slot="reference"
              type="text"
              class="danger"
              size="small"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column></el-table
    >

    <pagination
      class="mb-md mr-md"
      slot="append"
      :pageObj="filterForm"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>
    <el-dialog
      :title="dialogForm.id == null ? '新增活动' : '编辑活动'"
      :visible.sync="dialogShow"
      @closed="onDialogClose"
      top="20px"
    >
      <el-form
        v-loading="saving"
        class="content-box"
        label-width="140px"
        ref="dialogForm"
        :model="dialogForm"
        :rules="rules"
      >
        <el-form-item label="课外活动名称" prop="actTitle">
          <el-input
            v-model="dialogForm.actTitle"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="schoolYear" label="学年">
          <school-year-selector
            v-model="dialogForm.schoolYear"
            @change="resetoption"
          ></school-year-selector>
        </el-form-item>
        <el-form-item label="学期" prop="schoolTerm">
          <school-term-selector
            v-model="dialogForm.schoolTerm"
            @change="resetoption"
            :checkAll="false"
          ></school-term-selector>
        </el-form-item>
        <el-form-item prop="grade" label="年级">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.grade"
            placeholder="请选择年级"
            clearable
            @change="resetoption"
          >
            <el-option
              v-for="item in gradeOptions"
              :value="{ grade: item.grade, gradeName: item.gradeName }"
              :key="item.grade"
              :label="item.gradeName"
            ></el-option
          ></el-select>
        </el-form-item>
        <el-form-item prop="disciplineCode" label="学 科">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.disciplineCode"
            placeholder="请选择年级"
            clearable
            @change="resetoption"
          >
            <el-option
              v-for="item in disciplineOptions"
              :value="item.disciplineCode"
              :label="item.disciplineName"
              :key="item.disciplineCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="director" label="负责人">
          <el-select
            size="small"
            value-key="grade"
            v-model="dialogForm.director"
            placeholder="请选择负责人"
            @visible-change="directorChange"
          >
            <el-option
              v-for="item in directorOptions"
              :value="item.teacherId"
              :label="item.teacherName"
              :key="item.teacherId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="joinUserNum" label="参加人数">
          <el-input
            type="number"
            v-model="dialogForm.joinUserNum"
            placeholder="请输入参加人数"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item prop="weekActCount" label="活动次数（周）">
          <el-input
            type="number"
            v-model="dialogForm.weekActCount"
            placeholder="请输入活动次数（周）"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item prop="actContent" label="活动内容">
          <el-input
            type="textarea"
            v-model="dialogForm.actContent"
            :autosize="{ minRows: 3, maxRows: 5 }"
            placeholder="请输入活动内容"
          ></el-input>
        </el-form-item>
        <el-form-item prop="actEffect" label="效果">
          <el-input
            placeholder="请输入效果"
            type="textarea"
            v-model="dialogForm.actEffect"
            :autosize="{ minRows: 3, maxRows: 5 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import schoolYearSelector from "@/components/school/schoolYearSelector.vue";
import schoolTermSelector from "@/components/school/schoolTermSelector.vue";
import AuthorSelector from "@/components/school/authorSelector.vue";
import Pagination from "@/components/Pagination.vue";
import CardList from "@/components/researchGroup/CardList.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "@/http/fetch";
export default {
  components: {
    schoolYearSelector,
    schoolTermSelector,
    Pagination,
    AuthorSelector,
    CardList,
  },
  data() {
    return {
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: null,
        checkStatus: null,
        disciplineCode: null,
        grade: null,
        size: 10,
        current: 1,
        total: 0,
      },
      tableData: [],
      gradeOptions: [],
      disciplineOptions: [],
      directorOptions: [],
      pageLoading: false,
      dialogShow: false,
      saving: false,
      showSpeakPop: false,
      dialogForm: {
        id: null,
        actTitle: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        grade: null,
        disciplineCode: null,
        director: null,
        joinUserNum: null,
        weekActCount: null,
        actContent: null,
        actEffect: null,
      },
      rules: {
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        schoolTerm: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        joinUserNum: [
          { required: true, message: "请输入参加人数", trigger: "change" },
        ],
        weekActCount: [
          {
            required: true,
            message: "请输入活动次数（周）",
            trigger: "change",
          },
        ],
        actEffect: [
          { required: true, message: "请输入效果", trigger: "change" },
        ],
        actContent: [
          { required: true, message: "请输入活动内容", trigger: "change" },
        ],
        actTitle: [
          { required: true, message: "请输入课外活动名称", trigger: "change" },
        ],
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        director: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],
        disciplineCode: [
          { required: true, message: "请选择学科", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode"]),
  },
  mounted() {
    this.getData();
    this.getGradeList();
    this.getDisciplineFieldlList();
  },
  methods: {
    termFormatter(row, column, cellValue, index) {
      let result = cellValue == 1 ? "上学期" : "下学期";
      return result;
    },
    async getData() {
      this.loading = true;
      await postJson("/researchGroup/getActiveAfterClassList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        grade: this.filterForm.grade,
        disciplineCode: this.filterForm.disciplineCode,
        keyword: this.filterForm.keyword,
        isAdmin: this.isAdmin / 1,
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.filterForm.pageNum = 1;
      this.getData();
    },
    async getDisciplineFieldlList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/discipline/getDisciplinelList", {
          schoolCode: this.schoolCode,
        })
          .then((res) => {
            if (res.length) {
              res = res.map((m) => {
                return {
                  disciplineCode: m.disciplineCode,
                  disciplineName: m.disciplineName,
                };
              });
              this.disciplineOptions = res;
            } else {
              this.disciplineOptions = [];
            }
            resolve(res);
          })
          .catch((e) => {
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async getGradeList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/school/getGradeList", { schoolCode: this.schoolCode })
          .then((res) => {
            let list = [];
            if (res.length) {
              list = res;
              this.gradeOptions = res;
              resolve(list);
            } else {
              this.gradeOptions = [];
              reject();
              parse;
            }
          })
          .catch((e) => {
            reject(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    onDialogClose() {
      this.dialogForm = {
        actCode: null,
        id: null,
        actTitle: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        grade: null,
        disciplineCode: null,
        director: null,
        joinUserNum: null,
        weekActCount: null,
        actContent: null,
        actEffect: null,
      };
      this.$refs.dialogForm.resetFields();
    },
    onReset() {
      this.filterForm.disciplineCode = null;
      this.filterForm.schoolYear = null;
      this.filterForm.schoolTerm = null;
      this.filterForm.keyword = null;
      this.filterForm.grade = null;
      this.refresh();
    },
    onAdd() {
      this.dialogShow = true;
      this.dialogForm = {
        id: null,
        actCode: null,
        actTitle: null,
        schoolYear: null,
        schoolTerm: null,
        groupName: null,
        grade: null,
        disciplineCode: null,
        director: null,
        joinUserNum: null,
        weekActCount: null,
        actContent: null,
        actEffect: null,
      };
    },
    async toPathEdit(res) {
      this.dialogForm = {
        id: res.id,
        actCode: res.actCode,
        actContent: res.actContent,
        actEffect: res.actEffect,
        actTitle: res.actTitle,
        schoolYear: res.schoolYear,
        schoolTerm: res.schoolTerm,
        joinUserNum: res.joinUserNum,
        disciplineCode: res.disciplineCode,
        weekActCount: res.weekActCount,
        director: res.directorId,
        grade: {
          grade: res.grade,
          gradeName: res.gradeName,
        },
      };
      this.directorChange(true, true);
      this.dialogShow = true;
    },
    onSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          postJson("/researchGroup/saveOrUpdateActiveAfterClass", {
            id: this.dialogForm.id ? this.dialogForm.id : null,
            actContent: this.dialogForm.actContent,
            actEffect: this.dialogForm.actEffect,
            actTitle: this.dialogForm.actTitle,
            actCode: this.dialogForm.actCode ? this.dialogForm.actCode : null,
            disciplineCode: this.dialogForm.disciplineCode,
            disciplineName: this.disciplineOptions.find(
              (m) => m.disciplineCode == this.dialogForm.disciplineCode
            ).disciplineName,
            directorId: this.dialogForm.director,
            directorName: this.directorOptions.find(
              (m) => m.teacherId == this.dialogForm.director
            ).teacherName,
            grade: this.dialogForm.grade.grade,
            gradeName: this.dialogForm.grade.gradeName,
            joinUserNum: this.dialogForm.joinUserNum,
            operatorId: this.userInfo.userId,
            schoolCode: this.userInfo.schoolCode,
            schoolYear: this.dialogForm.schoolYear,
            schoolTerm: this.dialogForm.schoolTerm,
            weekActCount: this.dialogForm.weekActCount,
          })
            .then((res) => {
              this.dialogShow = false;
              this.$message.success("操作成功！");
              this.filterForm.pageNum = 1;
              this.getData();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.getData();
    },
    async directorChange(bool, isRe) {
      if (bool) {
        if (!this.dialogForm.schoolYear) {
          this.$message.warning("请先选择学年！");
          return;
        }
        if (!this.dialogForm.schoolTerm) {
          this.$message.warning("请先选择学期！");
          return;
        }
        if (!this.dialogForm.grade) {
          this.$message.warning("请先选择年级！");
          return;
        }
        if (!this.dialogForm.disciplineCode) {
          this.$message.warning("请先选择学科！");
          return;
        }
        await postData("/researchGroup/getGroupTeacherList", {
          schoolCode: this.userInfo.schoolCode,
          grade: this.dialogForm.grade.grade,
          disciplineCode: this.dialogForm.disciplineCode,
          schoolYear: this.dialogForm.schoolYear,
          schoolTerm: this.dialogForm.schoolTerm,
        }).then((res) => {
          this.directorOptions = res;
          if (!isRe) {
            this.dialogForm.director = null;
          }
        });
      }
    },
    resetoption() {
      this.dialogForm.director = null;
      this.directorOptions = [];
    },
    onDel(row) {
      this.saving = true;
      postJson("/researchGroup/deleteActiveAfterClass", {
        id: row.id,
        operatorId: this.userInfo.userId,
      })
        .then(() => {
          this.getData();
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="less" >
.authorSelector {
  margin-left: 0 !important;
}
.data-list {
  margin-top: 15px;
  background: #fff;
  padding: 15px;
  border-radius: 10px;
}
</style>